import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initReduxStore, store } from './store';
import Config from './config.json';
import { Provider } from 'react-redux';
import WebFontLoader from "webfontloader";

WebFontLoader.load({
  google: {
    families: ['Montserrat'],
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

initReduxStore(Config.USER_API_URL);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();